import { useGetMeetingLink } from '@/shared/api/meeting-link'
import { useBooking } from './bookingContext'
import { useMemo } from 'react'

export function useSelectedAvailability(meetingLinkSlug: string) {
  const { state } = useBooking()
  const { meetingLink } = useGetMeetingLink(meetingLinkSlug)

  const availabilities = meetingLink?.availabilities
  const selectedAvailabilityId = state.availabilityId
  const meetingPlace = state.meetingPlace

  const selectedAvailability = useMemo(() => {
    if (!availabilities) return

    // If we have a selected availability ID in context, find the matching availability
    if (selectedAvailabilityId) {
      return availabilities.find((availability) => availability._id === selectedAvailabilityId)
    }

    // Otherwise find by meeting place
    return availabilities.find((availability) => availability.meetingPlace === meetingPlace)
  }, [availabilities, meetingPlace, selectedAvailabilityId])

  return selectedAvailability
}

export type SelectedAvailability = ReturnType<typeof useSelectedAvailability>
